import React, { useRef } from "react";
import styled from "@emotion/styled";
import { Row, Col, Button } from "antd";
import {
  getLocations,
  getAllDepartmentList,
  getRoleList,
} from "redux/selectors";
import { connect } from "react-redux";
import moment from "moment";
import Icon from "atoms/Icon";
import { FileUnknownFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const StyledIcon = styled(Icon)`
  height: 60px;
  width: 60px;
`;

const StyledButton = styled(Button)`
  background: #26a4ff;
  border-radius: 5px;
  color: #ffffff;
  width: 100px;
  font-weight: bold;
`;

const StyledCol = styled(Col)`
  margin: 10px;
  .normal-column {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .info_heading {
    font-size: 14px;
    font-weight: 600;
    color: #636980;
  }
  .info_datas {
    font-weight: 500;
    color: #1f243b;
  }
  .inreview_title {
    font-size: 16px;
    font-weight: 600;
    width: 26%;
  }
  .inreview_boxes_container {
    display: flex;
    gap: 1rem;
  }
  .roles_location_review {
    width: max-content;
    min-height: 28px;
    font-size: 14px;
    font-weight: 400;
    color: #1f243b;
    padding: 5px 12px;
    border-radius: 4px;
    background-color: #f4f4f4;
    margin-bottom: 0;
  }
  .roles_location_review_section {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  .roles_location_review_wrap {
    width: 100%;
    display: flex;
    gap: 10px;
  }
`;

const InReview = ({
  BasicInformation,
  department,
  location,
  role,
  departmentList,
  locationList,
  roleList,
  create,
  setStep,
  step,
  loading,
  document,
}) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  const uploadedFiles = document?.map((file) => ({
    name: file?.name,
    type: file?.type,
    url: file?.response?.base64Data,
    uniqueId: file?.response?.uniqueId,
  }));

  const departmentdata =
    departmentList?.filter((item) =>
      department?.includes(item.department_id)
    ) || null;

  const locationdata =
    locationList?.filter((item) => location?.includes(item.location_id)) ||
    null;

  const roledata =
    roleList?.filter((item) => role?.includes(item.roleId)) || null;

  function convertToTitleCase(input) {
    var words = input.replace(/_/g, " ").split(" ");
    for (var i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    return words.join(" ");
  }

  const StyledIconNofile = {
    color: "green",
    fontSize: "50px",
    padding: "5px",
  };

  return (
    <>
      <Row className="p-2 flex-column">
        <StyledCol>
          <div className="inreview_boxes_container">
            <h5 className="inreview_title">{t("Basic")}</h5>
            <Row className="w-100">
              {BasicInformation &&
                Object.entries(BasicInformation).map(([key, value]) => {
                  const isMoment =
                    value &&
                    typeof value === "object" &&
                    typeof value.isValid === "function" &&
                    value._isAMomentObject;

                  return (
                    <React.Fragment key={key}>
                      {key !== "Policy Details" ? (
                        <Col className="inreview_col_section" xl={8}>
                          <b className="info_heading">
                            {convertToTitleCase(
                              key.charAt(0).toUpperCase() + key.slice(1)
                            )}
                          </b>
                          <p className="info_datas">
                            {key === "start_date" ||
                            key === "end_date" ||
                            key === "Policy Effective Date"
                              ? moment(value).format("DD MMMM YYYY")
                              : key === "expiry_date"
                              ? value
                                ? moment(value).format("MMMM YYYY")
                                : "-"
                              : isMoment
                              ? value.format("DD MMMM YYYY")
                              : value === false
                              ? t("False")
                              : value === true
                              ? t("True")
                              : value}
                          </p>
                        </Col>
                      ) : (
                        <Col xl={24}>
                          <b className="info_heading">
                            {convertToTitleCase(
                              key.charAt(0).toUpperCase() + key.slice(1)
                            )}
                          </b>
                          <div
                            ref={containerRef}
                            dangerouslySetInnerHTML={{ __html: value }}
                          />
                        </Col>
                      )}
                    </React.Fragment>
                  );
                })}
            </Row>
          </div>
        </StyledCol>

        {uploadedFiles?.length > 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Attachment")}</h5>
              <Row className="roles_location_review_wrap">
                {uploadedFiles?.map((item) => {
                  const fileKey = item?.uniqueId || item?.name;
                  const ext = item?.name.split(".").pop();

                  return (
                    <Col sm={24} md={8} xl={6} key={fileKey}>
                      {ext === "pdf" ? (
                        <Icon name="pdf" style={{ StyledIcon }} />
                      ) : ext === "jpg" ||
                        ext === "png" ||
                        ext === "jpeg" ||
                        ext === "svg" ? (
                        <Icon name="image" style={{ StyledIcon }} />
                      ) : ext === "xls" || ext === "csv" || ext === "xlsx" ? (
                        <Icon name="xl" style={{ StyledIcon }} />
                      ) : ext === "doc" || ext === "txt" || ext === "docx" ? (
                        <Icon name="word" style={{ StyledIcon }} />
                      ) : ext === "mp4" ? (
                        <Icon name="video" style={{ StyledIcon }} />
                      ) : (
                        <FileUnknownFilled style={StyledIconNofile} />
                      )}
                      <p className="normal-column">{item?.name}</p>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </StyledCol>
        )}

        {roledata?.length > 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Role")}</h5>
              <Row className="roles_location_review_wrap">
                {roledata?.map((item) => (
                  <Col key={item?.roleId}>
                    <p className="roles_location_review">{item?.roleName}</p>
                  </Col>
                ))}
              </Row>
            </div>
          </StyledCol>
        )}

        {locationdata?.length > 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Location")}</h5>
              <Row className="roles_location_review_wrap">
                {locationdata?.map((item) => (
                  <Col key={item?.location_id}>
                    <p className="roles_location_review">
                      {item?.location_name}
                    </p>
                  </Col>
                ))}
              </Row>
            </div>
          </StyledCol>
        )}

        {departmentdata?.length > 0 && (
          <StyledCol>
            <div className="inreview_boxes_container">
              <h5 className="inreview_title">{t("Department")}</h5>
              <Row className="roles_location_review_wrap">
                {departmentdata?.map((item) => (
                  <Col key={item?.department_id}>
                    <p className="roles_location_review">
                      {item?.department_name}
                    </p>
                  </Col>
                ))}
              </Row>
            </div>
          </StyledCol>
        )}
      </Row>

      <div className="w-100 text-end">
        <StyledButton
          type="primary"
          className="mt-3 mx-2"
          onClick={() => setStep(step - 1)}
        >
          {t("Back")}
        </StyledButton>

        <StyledButton
          className="mt-3"
          onClick={create}
          loading={loading}
          type="primary"
        >
          {t("Create")}
        </StyledButton>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  locationList: getLocations(state),
  departmentList: getAllDepartmentList(state),
  roleList: getRoleList(state),
});

export default connect(mapStateToProps)(InReview);
